import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {withTrackFont} from '../../containers/DataContainer/siteSettings/withTrackFont';
import {withoutSize} from '../../services/env/siteSettings/fonts/fonts';
import styles from './GoToSiteButton.scss';

const GoToSiteButtonComponent = ({trackFont, className, children, onClick}) => {
  const buttonStyles = withoutSize(trackFont);

  return (
    <button
      className={classnames([styles.goToSiteButton, className])}
      onClick={onClick}
      style={buttonStyles}
      data-hook="go-to-site-button"
    >
      {children}
    </button>
  );
};

GoToSiteButtonComponent.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  trackFont: PropTypes.object,
};

export const GoToSiteButton = withTrackFont(GoToSiteButtonComponent);
